import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=7956c9ce"
var script = {}
import style0 from "./BaseSpinner.vue?vue&type=style&index=0&id=7956c9ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports